import _typeof from "@babel/runtime/helpers/esm/typeof";

/**
 * @author tiantian
 * @version 0.1.0.0
 * @class milo.util.Form 表单方法
 * added to milo by cathzhang on 2011-12-27<br/>
 * @demo http://gameact.qq.com/milo/util/form.html
 */
var FormManager = {};
/**
 * 获取form对象（明显是一鸡肋）
 * @private
 * @param {string} dom id
 * @return {dom} dom对象
 */

FormManager._getContextDom = function (contextId) {
  var context = null;

  if (typeof contextId === 'string') {
    context = document.getElementById(contextId);
  } else if (_typeof(contextId) === 'object' && contextId) {
    context = contextId;
  }

  if (!context) {
    context = document;
  }

  return context;
};
/**
 * 取得所有表单的值
 * @param {string} dom id
 * @return {dom} dom对象
 */


FormManager.getAllInputValue = function (contextId) {
  var _dom = FormManager._getContextDom(contextId);

  var submitData = {};
  {
    // 所有input框，checkbox,radio
    var allInput = _dom.getElementsByTagName('input');

    if (allInput.length > 0) {
      for (var i = 0; i < allInput.length; i++) {
        var tempDom = allInput[i];
        var name_ = tempDom.getAttribute('name');
        var value_ = tempDom.value || '';

        if (!name_) {
          // 先看是否包含name属性
          continue;
        }

        var type_ = tempDom.getAttribute('type');

        if (!type_) {
          type_ = 'text';
        }

        type_ = type_.toLowerCase();
        {
          // 如果为button
          if (type_ == 'button') {
            continue;
          }
        }
        {
          // 如果为radio
          if (type_ == 'radio') {
            var checked_ = tempDom.checked;

            if (checked_) {
              submitData[name_] = value_;
            } else {
              if (typeof submitData[name_] === 'undefined') {
                submitData[name_] = '';
              }
            }

            continue;
          }
        }
        {
          // 如果为checkbox
          if (type_ == 'checkbox') {
            if (typeof submitData[name_] === 'undefined') {
              submitData[name_] = [];
            }

            var _checked_ = tempDom.checked;

            if (_checked_) {
              submitData[name_].push(value_);
            }

            continue;
          }
        } // 后面所有的都为text

        submitData[name_] = value_;
      }
    }
  }
  {
    // 取得所有select框
    var allSelect = _dom.getElementsByTagName('select');

    if (allSelect.length > 0) {
      for (var _i = 0; _i < allSelect.length; _i++) {
        var _tempDom = allSelect[_i];

        var _name_ = _tempDom.getAttribute('name');

        if (!_name_) {
          // 先看是否包含name属性
          continue;
        }

        var _value_ = [];

        var allOption = _tempDom.getElementsByTagName('option');

        for (var j = 0; j < allOption.length; j++) {
          var temp = allOption[j];
          var select_ = temp.selected;

          var __value = temp.value || '';

          if (select_) {
            // 存在select多选的情况
            _value_.push(__value);
          }
        }

        if (_value_.length == 0) {
          submitData[_name_] = '';
          continue;
        }

        if (_value_.length == 1) {
          // 单选
          // eslint-disable-line  prefer-destructuring
          submitData[_name_] = _value_[0];
          continue;
        }

        submitData[_name_] = _value_;
      }
    }
  }
  {
    // 取得所有textarea框
    var allTextarea = _dom.getElementsByTagName('textarea');

    if (allTextarea.length > 0) {
      for (var _i2 = 0; _i2 < allTextarea.length; _i2++) {
        var _tempDom2 = allTextarea[_i2];

        var _name_2 = _tempDom2.getAttribute('name');

        if (!_name_2) {
          // 先看是否包含name属性
          continue;
        }

        var _value_2 = _tempDom2.value || '';

        submitData[_name_2] = _value_2;
      }
    }
  }
  return submitData;
};
/**
 * 根据名字取得表单值
 * @param {string} name 表单name
 * @param {string} dom id
 * @return {string} 表单值
 */


FormManager.getInputValueByName = function (name, contextId) {
  var allInputValue = FormManager.getAllInputValue(contextId);
  return allInputValue[name] || '';
};
/**
 * 修改时填充某Form ID下所有表单的值,结构不能太复杂
 *  let json = {
 * 		text1 : 'abc',
 * 		text3 : '3',
 * 		text4 : ['5','6','7'],
 * 		text5 : '9',
 * 		text6 : 'uuuuuuuukkkkkk',
 *  	text7 : '10'
 *  };
 * @param {object} 表单对象 以key-value形式对应
 * @param {string} dom id
 * @return {dom} dom对象
 */


FormManager.setAllInputValue = function (json, contextId) {
  if (!json) {
    return false;
  }

  var _dom = FormManager._getContextDom(contextId);

  {
    // 所有input框，checkbox,radio
    var allInput = _dom.getElementsByTagName('input');

    if (allInput.length > 0) {
      for (var i = 0; i < allInput.length; i++) {
        var tempDom = allInput[i];
        var name_ = tempDom.getAttribute('name');

        if (!name_) {
          // 先看是否包含name属性
          continue;
        }

        if (typeof json[name_] === 'undefined') {
          continue;
        }

        var value_ = json[name_];
        var type_ = tempDom.getAttribute('type');

        if (!type_) {
          type_ = 'text';
        }

        type_ = type_.toLowerCase();
        {
          // 如果为button
          if (type_ == 'button') {
            continue;
          }
        }
        {
          // 如果为radio
          if (type_ == 'radio') {
            var value1_ = tempDom.value;

            if (value1_ == value_) {
              tempDom.setAttribute('checked', 'checked');
              tempDom.checked = 'checked';
            } else {
              tempDom.removeAttribute('checked');
              tempDom.checked = '';
            }

            continue;
          }
        }
        {
          // 如果为checkbox
          if (type_ == 'checkbox') {
            if (typeof value_ === 'string') {
              value_ = [value_];
            }

            var _value1_ = tempDom.value;
            var flag = false;

            for (var j = 0; j < value_.length; j++) {
              var v_ = value_[j];

              if (_value1_ == v_) {
                tempDom.setAttribute('checked', 'checked');
                tempDom.checked = 'checked';
                flag = true;
                break;
              }
            }

            if (!flag) {
              tempDom.removeAttribute('checked');
              tempDom.checked = '';
            }

            continue;
          }
        } // 后面所有的都为text

        tempDom.setAttribute('value', value_);
        tempDom.value = value_;
      }
    }
  }
  {
    // 取得所有select框
    var allSelect = _dom.getElementsByTagName('select');

    if (allSelect.length > 0) {
      for (var _i3 = 0; _i3 < allSelect.length; _i3++) {
        var _tempDom3 = allSelect[_i3];

        var _name_3 = _tempDom3.getAttribute('name');

        if (!_name_3) {
          // 先看是否包含name属性
          continue;
        }

        if (typeof json[_name_3] === 'undefined') {
          continue;
        }

        var _value_3 = json[_name_3];

        if (typeof _value_3 === 'string') {
          _value_3 = [_value_3];
        }

        var allOption = _tempDom3.getElementsByTagName('option');

        if (allOption.length == 0) {
          continue;
        }

        var selFlag = false;

        for (var _j = 0; _j < allOption.length; _j++) {
          var temp = allOption[_j];
          var _value1_2 = temp.value;
          var _flag = false;

          for (var k = 0; k < _value_3.length; k++) {
            var t = _value_3[k];

            if (t == _value1_2) {
              temp.setAttribute('selected', 'selected');
              temp.selected = 'selected';
              _flag = true;
              selFlag = true;
              break;
            }
          }

          if (!_flag) {
            // 存在select多选的情况
            temp.removeAttribute('selected');
            temp.selected = '';
          }
        }

        if (!selFlag) {
          // 如果一个都没选择的话
          // 如果是单选的话
          var multiple = _tempDom3.getAttribute('multiple');

          if (!multiple) {
            allOption[0].setAttribute('selected', 'selected');
            allOption[0].selected = 'selected';
          }
        }
      }
    }
  }
  {
    // 取得所有textarea框
    var allTextarea = _dom.getElementsByTagName('textarea');

    if (allTextarea.length > 0) {
      for (var _i4 = 0; _i4 < allTextarea.length; _i4++) {
        var _tempDom4 = allTextarea[_i4];

        var _name_4 = _tempDom4.getAttribute('name');

        if (!_name_4) {
          // 先看是否包含name属性
          continue;
        }

        if (typeof json[_name_4] === 'undefined') {
          continue;
        }

        _tempDom4.setAttribute('value', json[_name_4]);

        _tempDom4.value = json[_name_4];
      }
    }
  }
  return true;
};

export default FormManager;